import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  root: {
    height: '88px', // $unit-1 * 11 = 8px * 11
    width: '100%',
    padding: '16px 24px', // $unit-2 $unit-3
    background: semanticColors.background.primary,
    borderBottom: '1px solid #d0d5dd', // $border-gray-300
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    color: semanticColors.foreground.primary,
    fontWeight: foundations.typography.fontWeight.bold,
    paddingTop: 0,
    fontSize: '28px', // $unit-3 + $unit-half = 24px + 4px
    lineHeight: '40px', // $unit-5
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
    gap: '16px', // $unit-2
  },
  loadingBlock: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px', // 0 $unit-1
  },
  buttons: {
    display: 'flex',
    gap: '8px', // $unit-1
    maxHeight: '40px', // $unit-5
    alignItems: 'end',
  },
  button: {
    minHeight: '32px',
    height: '32px',
  },
  icon: {
    marginRight: '4px', // $unit-half
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  publicationName: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: semanticColors.foreground.secondary,
  },
});
